import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBubble4"><Path d="M18.502 3C19.8827 3 21.002 4.11929 21.002 5.5V17.5C21.002 18.8807 19.8827 20 18.502 20H7.78875C7.69504 20 7.60322 20.0263 7.52375 20.076L3.76695 22.424C3.61282 22.5203 3.41855 22.5254 3.25957 22.4373C3.10059 22.3492 3.00195 22.1818 3.00195 22V5.5C3.00195 4.11929 4.12124 3 5.50195 3H18.502Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble4;
